<template>
  <div>
    <b-table
      :data="intervenants"
      bordered striped>
      <b-table-column
        v-slot="props"
        :label="$i18n.t('ajoutDevis.table.customer')"
        field="nomCommercial">
        <span>
          <p class="label is-marginless">{{ props.row.titre }}
            <b-tooltip
              v-if="props.row.annonceur && func.getExonerationTva(props.row)"
              :label="$t('ajoutDevis.clients.clientExonerationTva')"
              type="is-warning"
              position="is-right">
              <b-icon
                icon="earth-arrow-right"
                class="is-cursor-pointer"
                size="is-small"
                type="is-warning">
              </b-icon>
            </b-tooltip>
            <b-tooltip
              v-if="props.row.tiers && props.row.tiers.prospect"
              :label="$t('ajoutDevis.clients.prospect')"
              type="is-warning"
              position="is-right">
              <b-icon
                icon="account-search"
                lass="is-cursor-pointer"
                size="is-small"
                type="is-warning">
              </b-icon>
            </b-tooltip>
          </p>
          <router-link-blank
            :to="{
              name: 'c.bodac.clients/contacts-client',
              params: { id: props.row.tiersId }
            }"
            :message="props.row.nomCommercial"
            class="lien">
          </router-link-blank>
        </span>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$i18n.t('ajoutDevis.table.contact')">
        <span v-if="props.row.contactId">
          <router-link-blank
            :to="{
              name: 'c.bodac.clients/contacts-client',
              params: { id: props.row.contactId }
            }"
            :message="getFullContactName(props.row.contact)"
            class="lien">
          </router-link-blank>
        </span>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$t('ajoutDevis.table.address')"
        field="adressePostale">
        <div>
          {{props.row.adressePostale.adresse1}}
          <span v-if="props.row.adressePostale.adresse2">
            <br/>{{props.row.adressePostale.adresse2}}
          </span>
          <span v-if="props.row.adressePostale.adresse3">
            <br/>{{props.row.adressePostale.adresse3}}
          </span>
          <br/>
          <span v-if="props.row.adressePostale.ville">
            {{props.row.adressePostale.codePostal}}
            - {{props.row.adressePostale.ville}}
          </span>
        </div>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$t('ajoutDevis.table.percentageOfBilling')"
        field="last_name"
        class="is-paddingless">
        <span> {{props.row.repartition}} </span>
        <span> {{getTypeRepartition(props.row.typeRepartition)}} </span>
      </b-table-column>
      <b-table-column
        field="annonceur"
        v-slot="props"
        :label="$t('ajoutDevis.table.advertiser')"
        centered>
        <b-checkbox
          v-if="props.row.nomCommercial"
          :value="props.row.annonceur"
          id="checkboxAnnonceur"
          disabled>
        </b-checkbox>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$t('ajoutDevis.table.mandatary')"
        centered>
        <b-checkbox
          v-if="props.row.nomCommercial"
          :value="props.row.mandataire"
          class="centrer-checkbox"
          id="checkboxMandataire"
          disabled>
        </b-checkbox>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$t('ajoutDevis.table.originator')"
        centered>
        <b-checkbox
          v-if="props.row.nomCommercial"
          :value="props.row.donneurOrdre"
          class="centrer-checkbox"
          id="checkboxDonneurOrdre"
          disabled>
        </b-checkbox>
      </b-table-column>
      <b-table-column
        v-slot="props"
        :label="$t('ajoutDevis.table.payer')"
        centered>
        <b-checkbox
          v-if="props.row.nomCommercial"
          :value="props.row.payeur"
          class="centrer-checkbox"
          id="checkboxPayeur"
          disabled>
        </b-checkbox>
        <niveau-blocage-icone
          v-if="props.row.tiers && props.row.tiers.blocageLevel"
          :niveau="props.row.tiers.blocageLevel"
          :description="props.row.tiers.descriptionBlocage"/>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import niveauBlocageIcone from '@/components/general/NiveauBlocageIcone';

export default {
  name: 'selection-client',
  props: {
    intervenants: {
      type: Array,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
    niveauBlocageIcone,
  },
  data() {
    return {
      func: { getExonerationTva },
    };
  },
  methods: {
    getTypeRepartition(value) {
      const find = devisConf.INTERVENANT_REPARTITION_TYPE.find(i => i.code === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    getFullContactName(contact) {
      let nomComplet = '';
      if (contact.fonction) {
        nomComplet = contact.fonction + ' - ';
      }
      return nomComplet + contact.nom + ' ' + contact.prenom;
    },
  },
};
</script>

<style>
</style>
